import React, { useEffect, useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import styles from 'assets/jss/material-dashboard-pro-react/views/regularFormsStyle';

import { Add, Assignment, Delete, PersonAdd, PersonAddDisabled, Visibility } from '@material-ui/icons';

import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { wsFindBy, wsPost } from 'services/WService';

//section tabs
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { Toasty, useToasty } from 'hooks/Toasty';
import Table from 'components/Table/Table';
import { wsRemove } from 'services/WService';
import RegularButton from 'components/CustomButtons/Button';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import ModalFilterBPartner from 'components/Tvendo/Common/ModalFilterBPartner';

const useStyles = makeStyles((theme) => ({
  ...styles,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

function Customer({ promotion }) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();

  const [value, setValue] = useState('1');
  const handleChange = (e, newValue) => {
    setValue(newValue);
  };

  const [customerGroups, setCustomerGroups] = useState([]);

  async function listCustomerGroups() {
    let response = await wsFindBy(`prom/promotion/${promotion.id}/customer-group`);
    if (response.success) {
      setCustomerGroups(response.data);
    }
  }

  async function onInputFileChange(e, type = 'INCLUDE') {
    let file = e.target.files[0];
    if (file === undefined) return;
    let formData = new FormData();
    formData.set('condition', type);
    formData.set('import', file);
    let res = await wsPost(`prom/promotion/${promotion.id}/customer-group`, formData);
    if (res.success) {
      showNotify(res.message);
      setCustomerGroups(res.data);
    } else {
      showNotify(res.message, 'error');
    }
  }

  async function deleteGroup(group) {
    let res = await wsRemove(
      `prom/promotion/${group.prom_promotion_id}/customer-group/${group.id}`,
    );
    if (res.success) {
      showNotify(res.message);
      setCustomerGroups(res.data);
    } else {
      showNotify(res.message, 'error');
    }
  }

  const [openList, setOpenList] = useState(false);
  const [listData, setListData] = useState([]);

  // Alta manual de clientes (uno por uno) usando el filtro de clientes
  const [openAdd, setOpenAdd] = useState(false);
  const [addCondition, setAddCondition] = useState('INCLUDE');

  function openAddCustomer(condition) {
    setAddCondition(condition);
    setOpenAdd(true);
  }

  async function addCustomer(bPartner) {
    let res = await wsPost(`prom/promotion/${promotion.id}/customer-group/customer`, {
      condition: addCondition,
      base_business_partner_id: bPartner.id,
    });
    if (res.success) {
      showNotify(res.message);
      setCustomerGroups(res.data);
    } else {
      showNotify(res.message, 'error');
    }
  }

  async function showCustomers(group) {
    setListData([]);
    setOpenList(true);
    let response = await wsFindBy('prom/customer', { prom_customer_group_id: group.id });
    setListData(response.success ? response.data : []);
  }

  const customerColumns = [
    { Header: '#', accessor: 'num', width: 80, excelEnabled: false },
    { Header: 'Código', accessor: 'code', width: 160 },
    { Header: 'Cliente', accessor: 'name' },
    { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
  ];

  const { indeterminated, groupType } = useMemo(() => {
    let indeterminated = customerGroups.length === 0;
    let groupType = undefined;
    if(customerGroups.length > 0){
      groupType = customerGroups[0].condition;
    }
    return {
      indeterminated,
      groupType
    };
  }, [customerGroups]);

  useEffect(() => {
    if (!!promotion.id) {
      listCustomerGroups();
    }
  }, [promotion]);

  return (
    <GridItem xs={12}>
      <Toasty action={notify} />
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Clientes</h4>
        </CardHeader>
        <CardBody>
          <div className={classes.root}>
            <TabContext value={indeterminated ? value : groupType === 'INCLUDE' ? "1" : "2"}>
              <AppBar position="static">
                <TabList onChange={handleChange}>
                  <Tab
                    icon={<PersonAdd />}
                    value="1"
                    label="Incluir clientes"
                    disabled={!indeterminated && groupType === 'EXCLUDE'}
                  />
                  <Tab
                    icon={<PersonAddDisabled />}
                    value="2"
                    label="Excluir clientes"
                    disabled={!indeterminated && groupType === 'INCLUDE'}
                  />
                </TabList>
              </AppBar>
              <TabPanel value="1">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                  <ImportExcel
                    setDataImport={console.log}
                    btnColor="success"
                    btnLabel="Importar"
                    validDuplicate="CODIGO CLIENTE"
                    sortDuplicate="CODIGO CLIENTE"
                    onChange={onInputFileChange}
                    downTemplate={{
                      fileNameDown: `promocion-${promotion.id}-incluir-clientes`,
                      fields: ['CODIGO CLIENTE'],
                    }}
                  />
                  <RegularButton color="success" round onClick={() => openAddCustomer('INCLUDE')}>
                    <Add /> Agregar cliente
                  </RegularButton>
                </div>
                {!indeterminated && groupType === 'INCLUDE' && (
                  <Table
                    striped
                    tableHead={['#', 'Clientes', 'Acciones']}
                    tableData={customerGroups.map((group, index) => {
                      return [
                        index + 1,
                        group.customers_count,
                        <>
                          <RegularButton
                            justIcon
                            simple
                            round
                            onClick={() => showCustomers(group)}
                            color="info"
                          >
                            <Visibility />
                          </RegularButton>
                          <RegularButton
                            justIcon
                            simple
                            round
                            onClick={() => deleteGroup(group)}
                            color="danger"
                          >
                            <Delete />
                          </RegularButton>
                        </>,
                      ];
                    })}
                  />
                )}
              </TabPanel>
              <TabPanel value="2">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                  <ImportExcel
                    setDataImport={console.log}
                    btnColor="success"
                    btnLabel="Importar"
                    validDuplicate="CODIGO CLIENTE"
                    sortDuplicate="CODIGO CLIENTE"
                    onChange={(e) => onInputFileChange(e, 'EXCLUDE')}
                    downTemplate={{
                      fileNameDown: `promocion-${promotion.id}-excluir-clientes`,
                      fields: ['CODIGO CLIENTE'],
                    }}
                  />
                  <RegularButton color="success" round onClick={() => openAddCustomer('EXCLUDE')}>
                    <Add /> Agregar cliente
                  </RegularButton>
                </div>
                {!indeterminated && groupType === 'EXCLUDE' && (
                  <Table
                    striped
                    tableHead={['#', 'Clientes', 'Acciones']}
                    tableData={customerGroups.map((group, index) => {
                      return [
                        index + 1,
                        group.customers_count,
                        <>
                          <RegularButton
                            justIcon
                            simple
                            round
                            onClick={() => showCustomers(group)}
                            color="info"
                          >
                            <Visibility />
                          </RegularButton>
                          <RegularButton
                            justIcon
                            simple
                            round
                            onClick={() => deleteGroup(group)}
                            color="danger"
                          >
                            <Delete />
                          </RegularButton>
                        </>,
                      ];
                    })}
                  />
                )}
              </TabPanel>
            </TabContext>
          </div>
        </CardBody>
      </Card>

      <ModalFull title="Clientes del grupo" open={openList} setOpen={setOpenList}>
        <Card>
          <CardBody>
            <ReactTable
              excelName="clientes-promocion"
              defaultWidth={700}
              columns={customerColumns}
              data={listData.map((c, i) => ({
                num: i + 1,
                code: c.CardCode,
                name: c.CardName,
              }))}
            />
          </CardBody>
        </Card>
      </ModalFull>

      <ModalFilterBPartner
        open={openAdd}
        setOpen={setOpenAdd}
        cardType="C"
        entity="base/business-partner"
        setBPartnerSelect={addCustomer}
      />
    </GridItem>
  );
}

export default Customer;
